import React from 'react';
import MenuItem from 'app/shared/layout/menus/menu-item';
import { Translate, translate } from 'react-jhipster';
import { NavDropdown } from './menu-components';

export const EntitiesMenu = props => (
  <NavDropdown
    icon="th-list"
    name={translate('global.menu.entities.main')}
    id="entity-menu"
    data-cy="entity"
    style={{ maxHeight: '80vh', overflow: 'auto' }}
  >
    <>{/* to avoid warnings when empty */}</>
    <MenuItem icon="asterisk" to="/ecole">
      <Translate contentKey="global.menu.entities.ecole" />
    </MenuItem>
    <MenuItem icon="asterisk" to="/classe">
      <Translate contentKey="global.menu.entities.classe" />
    </MenuItem>
    <MenuItem icon="asterisk" to="/eleve">
      <Translate contentKey="global.menu.entities.eleve" />
    </MenuItem>
    <MenuItem icon="asterisk" to="/parent">
      <Translate contentKey="global.menu.entities.parent" />
    </MenuItem>
    <MenuItem icon="asterisk" to="/pointage">
      <Translate contentKey="global.menu.entities.pointage" />
    </MenuItem>
    <MenuItem icon="asterisk" to="/surveillant">
      <Translate contentKey="global.menu.entities.surveillant" />
    </MenuItem>
    <MenuItem icon="asterisk" to="/directeur">
      <Translate contentKey="global.menu.entities.directeur" />
    </MenuItem>
    <MenuItem icon="asterisk" to="/professeur">
      <Translate contentKey="global.menu.entities.professeur" />
    </MenuItem>
    <MenuItem icon="asterisk" to="/notification">
      Notification
    </MenuItem>
    {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
  </NavDropdown>
);
